module.exports = __webpack_public_path__ + "img/no_sensor_allocated.725dd01e.png";